import type { FunctionComponent, ReactNode } from 'react';

type WithSeparatorProps = {
  children: ReactNode,
  position?: 'before' | 'after'
};

const separator = () => {
  return (<div className="issue-item__field-separator"><span>•</span></div>);
};

/**
 * Renders children with a separator character (eg: "•")
 */
const WithSeparator: FunctionComponent<WithSeparatorProps> = ({
  children,
  position,
}) => (
  position && position === 'before' ? (
    <>
      {separator()}
      {children}
    </>
  ) : (
    <>
      {children}
      {separator()}
    </>
  )
);

export default WithSeparator;
